export const table = {
  'commissioner_votes-list': {
    path_name: 'commissioner_vote-review',
    columns: [
      {
        name: 'review_status',
        isSortable: false,
      },
      {
        name: 'number',
        isSortable: true,
        alignCenter: true,
      },
      {
        name: 'name_of_legal_entity',
        isSortable: true,
      },
      {
        name: 'categorization_name',
        isSortable: true,
      },
      {
        name: 'submitted_at',
        isSortable: true,
        type: 'date',
      },
      {
        name: 'voting_at',
        isSortable: true,
        type: 'date',
      },
    ],
    tooltip: {
      waiting_for_voting: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        // {
        //   name: 'downloadPDF',
        //   isRouting: false,
        //   handler: 'downloadPDF',
        // },
      ],
    },
    actions: {
      waiting_for_voting: 'readonly',
    },
  },
  'commissioner_history-list': {
    path_name: 'commissioner_history-review',
    columns: [
      {
        name: 'review_status',
        isSortable: true,
      },
      {
        name: 'number',
        isSortable: true,
      },
      {
        name: 'name_of_legal_entity',
        isSortable: true,
      },
      {
        name: 'categorization_name',
        isSortable: true,
      },
      {
        name: 'submitted_at',
        isSortable: true,
        type: 'date',
      },
      {
        name: 'voting_at',
        isSortable: true,
        type: 'date',
      },
    ],
    tooltip: {
      approved: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
      declined: [
        {
          name: 'readonly',
          type_action: 'readonly',
          isRouting: true,
          handler: null,
        },
        {
          name: 'downloadPDF',
          isRouting: false,
          handler: 'downloadFile',
        },
      ],
    },
    actions: {
      approved: 'readonly',
      declined: 'readonly',
    },
  },
};
